import {
  fetchGetFederalSubjectsOfRussia,
  IGetFederalSubjectsOfRussiaResponse200 as IRes200,
  IGetFederalSubjectsOfRussiaResponse400 as IRes400,
} from '../../repositories/geo-temp-layer/v1/get-federal-subjects-of-russia';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';
import { IConfig } from '@cian/config/shared';
import { ILocation } from '../../types/location';
import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

export interface IGetLocationsDeps {
  httpApi: IHttpApi;
  logger: ILogger;
  config: IConfig;
}

export function getLocations(deps: IGetLocationsDeps): Promise<ILocation[]> {
  const { httpApi, logger } = deps;

  return fetchGetFederalSubjectsOfRussia<IRes200, IRes400>({
    httpApi,
  })
    .then(response => {
      if (response.statusCode === 200) {
        return response.response.items.map(item => {
          return {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            id: item!.id as number,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            displayName: item!.displayName as string,
          };
        });
      }

      throw new HttpBadStatusCodeError(
        'Bad request geo-temp-layer/v1/get-federal-subjects-of-russia',
        response.statusCode,
      );
    })
    .catch(error => {
      if (error instanceof HttpBadStatusCodeError) {
        logger.error(error.message);
      } else {
        logger.error('Unable to send request geo-temp-layer/v1/get-federal-subjects-of-russia', error);
      }

      throw error;
    });
}
